import React from 'react';
import WorkDayDashboard from '../components/workday/WorkDayDashboard';
import './NurseDashboard.css';

// Medicinska sestra / negovateljica - "Moj radni dan" sa zadacima nege.
const NurseDashboard = () => (
  <div className="nurse-dashboard">
    <WorkDayDashboard tasksEndpoint="/api/Task/nurse-tasks" />
  </div>
);

export default NurseDashboard;
